// テキスト範囲専用書式パネルの識別属性。
//
// エディタ（useObjectTextEditor）は、フォーカスがこのパネルの内側へ移った blur では編集を
// 終了しない（範囲パネルの操作でエディタの選択が失われないようにする）。パネル側とエディタ側で
// 属性名がずれると「操作した瞬間に編集が終わる」退行になるため、名前をここへ集約する。

export const TEXT_RANGE_PANEL_ATTRIBUTE = "data-canvas-text-range-panel";
